const figma = [
  {
    name: 'colorPrimaryBg',
    value: '#E9F5FE',
    describe: '浅色背景',
    token: 'Brand-1',
    locked: false,
  },
  {
    name: 'colorPrimaryFocus',
    value: '#BDE2FF',
    describe: '聚焦',
    token: 'Brand-2',
    locked: false,
  },
  {
    name: '山药品牌色-10',
    value: '#001D61',
    describe: '-10',
    token: 'Brand-10',
    locked: true,
  },
  {
    name: 'colorPrimaryDisabled',
    value: '#94CDFF',
    describe: '禁用',
    token: 'Brand-3',
    locked: false,
  },
  {
    name: '山药品牌色-4',
    value: '#6BB5FF',
    describe: '-4',
    token: 'Brand-4',
    locked: true,
  },
  {
    name: 'colorPrimaryHover',
    value: '#429AFF',
    describe: '悬浮',
    token: 'Brand-5',
    locked: false,
  },
  {
    name: 'colorPrimary',
    value: '#197AFA',
    describe: '常规',
    token: 'Brand-6',
    locked: false,
  },
  {
    name: 'colorPrimaryActive',
    value: '#0B5BD4',
    describe: '点击',
    token: 'Brand-7',
    locked: false,
  },
  {
    name: '山药品牌色-8',
    value: '#0040AD',
    describe: '-8',
    token: 'Brand-8',
    locked: true,
  },
  {
    name: '山药品牌色-9',
    value: '#002D87',
    describe: '-9',
    token: 'Brand-9',
    locked: true,
  },
  {
    name: '青色-1',
    value: '#E3FEFA',
    describe: '浅色背景',
    token: 'Cyan-1',
    locked: true,
  },
  {
    name: '青色-10',
    value: '#051F24',
    describe: '-10',
    token: 'Cyan-10',
    locked: true,
  },
  {
    name: '青色-2',
    value: '#ADF2E9',
    describe: '聚焦',
    token: 'Cyan-2',
    locked: true,
  },
  {
    name: '青色-3',
    value: '#7DE3D9',
    describe: '禁用',
    token: 'Cyan-3',
    locked: true,
  },
  {
    name: '青色-4',
    value: '#54D4CC',
    describe: '-4',
    token: 'Cyan-4',
    locked: true,
  },
  {
    name: '青色-5',
    value: '#34C6C1',
    describe: '悬浮',
    token: 'Cyan-5',
    locked: true,
  },
  {
    name: '青色-6',
    value: '#1DB8B9',
    describe: '常规',
    token: 'Cyan-6',
    locked: true,
  },
  {
    name: '青色-7',
    value: '#158B90',
    describe: '点击',
    token: 'Cyan-7',
    locked: true,
  },
  {
    name: '青色-8',
    value: '#0D6169',
    describe: '-8',
    token: 'Cyan-8',
    locked: true,
  },
  {
    name: '青色-9',
    value: '#093D45',
    describe: '-9',
    token: 'Cyan-9',
    locked: true,
  },
  {
    name: 'colorDangerBg',
    value: '#FCE6E6',
    describe: '浅色背景',
    token: 'Danger-1',
    locked: false,
  },
  {
    name: '危险色-10',
    value: '#4D000A',
    describe: '-10',
    token: 'Danger-10',
    locked: true,
  },
  {
    name: 'colorDangerFocus',
    value: '#F7C1C0',
    describe: '聚焦',
    token: 'Danger-2',
    locked: false,
  },
  {
    name: 'colorDangerDisabled',
    value: '#F29896',
    describe: '禁用',
    token: 'Danger-3',
    locked: false,
  },
  {
    name: '危险色-4',
    value: '#F38981',
    describe: '-4',
    token: 'Danger-4',
    locked: true,
  },
  {
    name: 'colorDangerHover',
    value: '#EF6661',
    describe: '悬浮',
    token: 'Danger-5',
    locked: false,
  },
  {
    name: 'colorDanger',
    value: '#EB4242',
    describe: '常规',
    token: 'Danger-6',
    locked: false,
  },
  {
    name: 'colorDangerActive',
    value: '#CC2C29',
    describe: '点击',
    token: 'Danger-7',
    locked: false,
  },
  {
    name: '危险色-8',
    value: '#9C161F',
    describe: '-8',
    token: 'Danger-8',
    locked: true,
  },
  {
    name: '危险色-9',
    value: '#740813',
    describe: '-9',
    token: 'Danger-9',
    locked: true,
  },
  {
    name: '靛蓝色-1',
    value: '#EEF2FE',
    describe: '浅色背景',
    token: 'Indigo-1',
    locked: true,
  },
  {
    name: '靛蓝色-10',
    value: '#170F69',
    describe: '-10',
    token: 'Indigo-10',
    locked: true,
  },
  {
    name: '靛蓝色-2',
    value: '#D7DDFF',
    describe: '聚焦',
    token: 'Indigo-2',
    locked: true,
  },
  {
    name: '靛蓝色-3',
    value: '#ABB4FB',
    describe: '禁用',
    token: 'Indigo-3',
    locked: true,
  },
  {
    name: '靛蓝色-4',
    value: '#848FF9',
    describe: '-4',
    token: 'Indigo-4',
    locked: true,
  },
  {
    name: '靛蓝色-5',
    value: '#6972F6',
    describe: '悬浮',
    token: 'Indigo-5',
    locked: true,
  },
  {
    name: '靛蓝色-6',
    value: '#4446F7',
    describe: '常规',
    token: 'Indigo-6',
    locked: true,
  },
  {
    name: '靛蓝色-7',
    value: '#3431CD',
    describe: '点击',
    token: 'Indigo-7',
    locked: true,
  },
  {
    name: '靛蓝色-8',
    value: '#2822A6',
    describe: '-8',
    token: 'Indigo-8',
    locked: true,
  },
  {
    name: '靛蓝色-9',
    value: '#1E1782',
    describe: '-9',
    token: 'Indigo-9',
    locked: true,
  },
  {
    name: '柠檬黄色-1',
    value: '#FCFADE',
    describe: '浅色背景',
    token: 'Lemon-1',
    locked: true,
  },
  {
    name: '柠檬黄色-10',
    value: '#4D3000',
    describe: '-10',
    token: 'Lemon-10',
    locked: true,
  },
  {
    name: '柠檬黄色-2',
    value: '#FFF9BF',
    describe: '聚焦',
    token: 'Lemon-2',
    locked: true,
  },
  {
    name: '柠檬黄色-3',
    value: '#FFE76C',
    describe: '禁用',
    token: 'Lemon-3',
    locked: true,
  },
  {
    name: '柠檬黄色-4',
    value: '#FFE76C',
    describe: '-4',
    token: 'Lemon-4',
    locked: true,
  },
  {
    name: '柠檬黄色-5',
    value: '#FFD943',
    describe: '悬浮',
    token: 'Lemon-5',
    locked: true,
  },
  {
    name: '柠檬黄色-6',
    value: '#FFC91A',
    describe: '常规',
    token: 'Lemon-6',
    locked: true,
  },
  {
    name: '柠檬黄色-7',
    value: '#D29F10',
    describe: '点击',
    token: 'Lemon-7',
    locked: true,
  },
  {
    name: '柠檬黄色-8',
    value: '#A67708',
    describe: '-8',
    token: 'Lemon-8',
    locked: true,
  },
  {
    name: '柠檬黄色-9',
    value: '#795203',
    describe: '-9',
    token: 'Lemon-9',
    locked: true,
  },
  {
    name: '洋红色-1',
    value: '#FCF1F6',
    describe: '浅色背景',
    token: 'Magenta-1',
    locked: true,
  },
  {
    name: '洋红色-10',
    value: '#4B0C37',
    describe: '-10',
    token: 'Magenta-10',
    locked: true,
  },
  {
    name: '洋红色-2',
    value: '#F8D8E6',
    describe: '聚焦',
    token: 'Magenta-2',
    locked: true,
  },
  {
    name: '洋红色-3',
    value: '#F3B1D0',
    describe: '禁用',
    token: 'Magenta-3',
    locked: true,
  },
  {
    name: '洋红色-4',
    value: '#EF8BBE',
    describe: '-4',
    token: 'Magenta-4',
    locked: true,
  },
  {
    name: '洋红色-5',
    value: '#E564A8',
    describe: '悬浮',
    token: 'Magenta-5',
    locked: true,
  },
  {
    name: '洋红色-6',
    value: '#D84293',
    describe: '常规',
    token: 'Magenta-6',
    locked: true,
  },
  {
    name: '洋红色-7',
    value: '#B4317D',
    describe: '点击',
    token: 'Magenta-7',
    locked: true,
  },
  {
    name: '洋红色-8',
    value: '#912266',
    describe: '-8',
    token: 'Magenta-8',
    locked: true,
  },
  {
    name: '洋红色-9',
    value: '#6E164E',
    describe: '-9',
    token: 'Magenta-9',
    locked: true,
  },
  {
    name: '荧光绿色-1',
    value: '#F1FAE1',
    describe: '浅色背景',
    token: 'Neon-1',
    locked: true,
  },
  {
    name: '荧光绿色-10',
    value: '#194D00',
    describe: '-10',
    token: 'Neon-10',
    locked: true,
  },
  {
    name: '荧光绿色-2',
    value: '#DDF2BE',
    describe: '聚焦',
    token: 'Neon-2',
    locked: true,
  },
  {
    name: '荧光绿色-3',
    value: '#C4E598',
    describe: '禁用',
    token: 'Neon-3',
    locked: true,
  },
  {
    name: '荧光绿色-4',
    value: '#AAD974',
    describe: '-4',
    token: 'Neon-4',
    locked: true,
  },
  {
    name: '荧光绿色-5',
    value: '#90CC54',
    describe: '悬浮',
    token: 'Neon-5',
    locked: true,
  },
  {
    name: '荧光绿色-6',
    value: '#77BF37',
    describe: '常规',
    token: 'Neon-6',
    locked: true,
  },
  {
    name: '荧光绿色-7',
    value: '#5AA223',
    describe: '点击',
    token: 'Neon-7',
    locked: true,
  },
  {
    name: '荧光绿色-8',
    value: '#418613',
    describe: '-8',
    token: 'Neon-8',
    locked: true,
  },
  {
    name: '荧光绿色-9',
    value: '#2B6908',
    describe: '-9',
    token: 'Neon-9',
    locked: true,
  },
  {
    name: '中性色-1',
    value: '#000000',
    describe: '浅色背景',
    token: 'Neutral-1',
    locked: true,
  },
  {
    name: '中性色-10',
    value: '#020B18',
    describe: '-10',
    token: 'Neutral-10',
    locked: true,
  },
  {
    name: '中性色-2',
    value: '#F4F5F8',
    describe: '聚焦',
    token: 'Neutral-2',
    locked: true,
  },
  {
    name: '中性色-3',
    value: '#E8EBF0',
    describe: '禁用',
    token: 'Neutral-3',
    locked: true,
  },
  {
    name: '中性色-4',
    value: '#CCCFD7',
    describe: '-4',
    token: 'Neutral-4',
    locked: true,
  },
  {
    name: '中性色-5',
    value: '#B3B7C1',
    describe: '悬浮',
    token: 'Neutral-5',
    locked: true,
  },
  {
    name: '中性色-6',
    value: '#999DA8',
    describe: '常规',
    token: 'Neutral-6',
    locked: true,
  },
  {
    name: '中性色-7',
    value: '#666C7C',
    describe: '点击',
    token: 'Neutral-7',
    locked: true,
  },
  {
    name: '中性色-8',
    value: '#333E59',
    describe: '-8',
    token: 'Neutral-8',
    locked: true,
  },
  {
    name: '中性色-9',
    value: '#141737',
    describe: '-9',
    token: 'Neutral-9',
    locked: true,
  },
  {
    name: '橘黄色-1',
    value: '#FFF8E6',
    describe: '浅色背景',
    token: 'Orange-1',
    locked: true,
  },
  {
    name: '橘黄色-10',
    value: '#4D2100',
    describe: '-10',
    token: 'Orange-10',
    locked: true,
  },
  {
    name: '橘黄色-2',
    value: '#FFEABA',
    describe: '聚焦',
    token: 'Orange-2',
    locked: true,
  },
  {
    name: '橘黄色-3',
    value: '#FFD98D',
    describe: '禁用',
    token: 'Orange-3',
    locked: true,
  },
  {
    name: '橘黄色-4',
    value: '#FFC45F',
    describe: '悬浮',
    token: 'Orange-4',
    locked: true,
  },
  {
    name: '橘黄色-5',
    value: '#FFAD32',
    describe: '悬浮',
    token: 'Orange-5',
    locked: true,
  },
  {
    name: '橘黄色-6',
    value: '#FF9204',
    describe: '常规',
    token: 'Orange-6',
    locked: true,
  },
  {
    name: '橘黄色-7',
    value: '#D27102',
    describe: '点击',
    token: 'Orange-7',
    locked: true,
  },
  {
    name: '橘黄色-8',
    value: '#A65401',
    describe: '-8',
    token: 'Orange-8',
    locked: true,
  },
  {
    name: '橘黄色-9',
    value: '#793900',
    describe: '-9',
    token: 'Orange-9',
    locked: true,
  },
  {
    name: '褐色-1',
    value: '#FAF4E3',
    describe: '浅色背景',
    token: 'Brown-1',
    locked: true,
  },
  {
    name: '褐色-10',
    value: '#4D2100',
    describe: '-10',
    token: 'Brown-10',
    locked: true,
  },
  {
    name: '褐色-2',
    value: '#EBDDBC',
    describe: '聚焦',
    token: 'Brown-2',
    locked: true,
  },
  {
    name: '褐色-3',
    value: '#D6C094',
    describe: '禁用',
    token: 'Brown-3',
    locked: true,
  },
  {
    name: '褐色-4',
    value: '#C2A470',
    describe: '悬浮',
    token: 'Brown-4',
    locked: true,
  },
  {
    name: '褐色-5',
    value: '#AD8951',
    describe: '悬浮',
    token: 'Brown-5',
    locked: true,
  },
  {
    name: '褐色-6',
    value: '#996F37',
    describe: '常规',
    token: 'Brown-6',
    locked: true,
  },
  {
    name: '褐色-7',
    value: '#865824',
    describe: '点击',
    token: 'Brown-7',
    locked: true,
  },
  {
    name: '褐色-8',
    value: '#734415',
    describe: '-8',
    token: 'Brown-8',
    locked: true,
  },
  {
    name: '褐色-9',
    value: '#603109',
    describe: '-9',
    token: 'Brown-9',
    locked: true,
  },
  {
    name: '紫色-1',
    value: '#F8EEFE',
    describe: '浅色背景',
    token: 'Purple-1',
    locked: true,
  },
  {
    name: '紫色-10',
    value: '#150530',
    describe: '-10',
    token: 'Purple-10',
    locked: true,
  },
  {
    name: '紫色-2',
    value: '#EDD6FE',
    describe: '聚焦',
    token: 'Purple-2',
    locked: true,
  },
  {
    name: '紫色-3',
    value: '#CFA3F3',
    describe: '禁用',
    token: 'Purple-3',
    locked: true,
  },
  {
    name: '紫色-4',
    value: '#AD72E4',
    describe: '-4',
    token: 'Purple-4',
    locked: true,
  },
  {
    name: '紫色-5',
    value: '#8B48D5',
    describe: '悬浮',
    token: 'Purple-5',
    locked: true,
  },
  {
    name: '紫色-6',
    value: '#6C23C6',
    describe: '常规',
    token: 'Purple-6',
    locked: true,
  },
  {
    name: '紫色-7',
    value: '#4E159E',
    describe: '点击',
    token: 'Purple-7',
    locked: true,
  },
  {
    name: '紫色-8',
    value: '#360C77',
    describe: '-8',
    token: 'Purple-8',
    locked: true,
  },
  {
    name: '紫色-9',
    value: '#220652',
    describe: '-9',
    token: 'Purple-9',
    locked: true,
  },
  {
    name: 'colorSuccessBg',
    value: '#E4FCED',
    describe: '浅色背景',
    token: 'Success-1',
    locked: false,
  },
  {
    name: 'colorSuccessFocus',
    value: '#ADEEC9',
    describe: '聚焦',
    token: 'Success-2',
    locked: false,
  },
  {
    name: '成功色-10',
    value: '#004D36',
    describe: '-10',
    token: 'Success-10',
    locked: true,
  },
  {
    name: 'colorSuccessDisabled',
    value: '#78DCA7',
    describe: '禁用',
    token: 'Success-3',
    locked: false,
  },
  {
    name: '成功色-4',
    value: '#4ACB8A',
    describe: '-4',
    token: 'Success-4',
    locked: true,
  },
  {
    name: 'colorSuccessHover',
    value: '#22B973',
    describe: '悬浮',
    token: 'Success-5',
    locked: false,
  },
  {
    name: 'colorSuccess',
    value: '#00A85F',
    describe: '常规',
    token: 'Success-6',
    locked: false,
  },
  {
    name: 'colorSuccessActive',
    value: '#009157',
    describe: '点击',
    token: 'Success-7',
    locked: false,
  },
  {
    name: '成功色-8',
    value: '#007A4D',
    describe: '-8',
    token: 'Success-8',
    locked: true,
  },
  {
    name: '成功色-9',
    value: '#006342',
    describe: '-9',
    token: 'Success-9',
    locked: true,
  },
  {
    name: '橘红色-1',
    value: '#FFF0E5',
    describe: '浅色背景',
    token: 'Tangerine-1',
    locked: true,
  },
  {
    name: '橘红色-10',
    value: '#56130A',
    describe: '-10',
    token: 'Tangerine-10',
    locked: true,
  },
  {
    name: '橘红色-2',
    value: '#FED4B9',
    describe: '聚焦',
    token: 'Tangerine-2',
    locked: true,
  },
  {
    name: '橘红色-3',
    value: '#FDB58F',
    describe: '禁用',
    token: 'Tangerine-3',
    locked: true,
  },
  {
    name: '橘红色-4',
    value: '#FD9568',
    describe: '-4',
    token: 'Tangerine-4',
    locked: true,
  },
  {
    name: '橘红色-5',
    value: '#FD7445',
    describe: '悬浮',
    token: 'Tangerine-5',
    locked: true,
  },
  {
    name: '橘红色-6',
    value: '#F75229',
    describe: '常规',
    token: 'Tangerine-6',
    locked: true,
  },
  {
    name: '橘红色-7',
    value: '#CD3A1D',
    describe: '点击',
    token: 'Tangerine-7',
    locked: true,
  },
  {
    name: '橘红色-8',
    value: '#A22614',
    describe: '-8',
    token: 'Tangerine-8',
    locked: true,
  },
  {
    name: '橘红色-9',
    value: '#7B1B0E',
    describe: '-9',
    token: 'Tangerine-9',
    locked: true,
  },
  {
    name: 'colorWarningBg',
    value: '#FFF3E2',
    describe: '浅色背景',
    token: 'Warning-1',
    locked: false,
  },
  {
    name: '警告色-10',
    value: '#4D1600',
    describe: '-10',
    token: 'Warning-10',
    locked: true,
  },
  {
    name: 'colorWarningFocus',
    value: '#FDDFBA',
    describe: '聚焦',
    token: 'Warning-2',
    locked: false,
  },
  {
    name: 'colorWarningDisabled',
    value: '#FBC68D',
    describe: '禁用',
    token: 'Warning-3',
    locked: false,
  },
  {
    name: '警告色-4',
    value: '#FDBB66',
    describe: '-4',
    token: 'Warning-4',
    locked: true,
  },
  {
    name: 'colorWarningHover',
    value: '#F78C35',
    describe: '悬浮',
    token: 'Warning-5',
    locked: false,
  },
  {
    name: 'colorWarning',
    value: '#F56C0A',
    describe: '常规',
    token: 'Warning-6',
    locked: false,
  },
  {
    name: 'colorWarningActive',
    value: '#CB5206',
    describe: '点击',
    token: 'Warning-7',
    locked: false,
  },
  {
    name: '警告色-8',
    value: '#A13A03',
    describe: '-8',
    token: 'Warning-8',
    locked: true,
  },
  {
    name: '警告色-9',
    value: '#772601',
    describe: '-9',
    token: 'Warning-9',
    locked: true,
  },
  {
    name: 'colorText',
    token: 'Neutral-text-5',
    value: '#141737',
    describe: '主要/正文文字',
    locked: false,
  },
  {
    name: 'colorTextSecondary',
    token: 'Neutral-text-4',
    value: '#666C7C',
    describe: '次要文字',
    locked: false,
  },
  {
    name: 'colorTextTertiary',
    token: 'Neutral-text-3',
    value: '#999DA8',
    describe: '辅助文字',
    locked: false,
  },
  {
    name: 'colorTextDisabled',
    token: 'Neutral-text-2',
    value: '#B3B7C1',
    describe: '禁用文字颜色',
    locked: false,
  },
  {
    name: '文字色',
    token: 'Neutral-text-1',
    value: '#FFFFFF',
    describe: '纯白文字',
    locked: true,
  },
  {
    name: 'colorBorderDisabled',
    token: 'Neutral-border-2',
    value: '#CCCFD7',
    describe: '默认/禁用边框',
    locked: false,
  },
  {
    name: 'colorBorder',
    token: 'Neutral-border-1',
    value: '#E8EBF0',
    describe: '分割线',
    locked: false,
  },
  {
    name: '填充色',
    token: 'Neutral-fill-7',
    value: '#666C7C',
    describe: '',
    locked: true,
  },
  {
    name: '填充色',
    token: 'Neutral-fill-5',
    value: '#B3B7C1',
    describe: '',
    locked: true,
  },
  {
    name: '填充色',
    token: 'Neutral-fill-9',
    value: '#141737',
    describe: '',
    locked: true,
  },
  {
    name: '填充色',
    token: 'Neutral-fill-10',
    value: '#020B18',
    describe: '',
    locked: true,
  },
  {
    name: '填充色',
    token: 'Neutral-fill-6',
    value: '#999DA8',
    describe: '',
    locked: true,
  },
  {
    name: '填充色',
    token: 'Neutral-fill-8',
    value: '#333E59',
    describe: '',
    locked: true,
  },
  {
    name: 'colorFillActive',
    token: 'Neutral-fill-4',
    value: '#CCCFD7',
    describe: '点击',
    locked: false,
  },
  {
    name: 'colorFillHover',
    token: 'Neutral-fill-3',
    value: '#E8EBF0',
    describe: '悬浮',
    locked: false,
  },
  {
    name: 'colorFillDisabled',
    token: 'Neutral-fill-2',
    value: '#F4F5F8',
    describe: '禁用/表头/底层背景',
    locked: false,
  },
  {
    name: 'colorWhiteBg',
    token: 'Neutral-fill-1',
    value: '#FFFFFF',
    describe: '白色背景',
    locked: false,
  },
  {
    name: '1/padding',
    value: '1px',
    describe: '1 内边距',
    token: 'Padding-1',
    locked: true,
  },
  {
    name: '2/padding',
    value: '2px',
    describe: '2 内边距',
    token: 'Padding-2',
    locked: true,
  },
  {
    name: '3/padding',
    value: '3px',
    describe: '3 内边距',
    token: 'Padding-3',
    locked: true,
  },
  {
    name: '4/padding',
    value: '4px',
    describe: '4 内边距',
    token: 'Padding-4',
    locked: true,
  },
  {
    name: '5/padding',
    value: '5px',
    describe: '5 内边距',
    token: 'Padding-5',
    locked: true,
  },
  {
    name: '6/padding',
    value: '6px',
    describe: '6 内边距',
    token: 'Padding-6',
    locked: true,
  },
  {
    name: '7/padding',
    value: '7px',
    describe: '7 内边距',
    token: 'Padding-7',
    locked: true,
  },
  {
    name: '8/padding',
    value: '8px',
    describe: '8 内边距',
    token: 'Padding-8',
    locked: true,
  },
  {
    name: '9/padding',
    value: '9px',
    describe: '9 内边距',
    token: 'Padding-9',
    locked: true,
  },
  {
    name: '10/padding',
    value: '10px',
    describe: '10 内边距',
    token: 'Padding-10',
    locked: true,
  },
  {
    name: '11/padding',
    value: '11px',
    describe: '11 内边距',
    token: 'Padding-11',
    locked: true,
  },
  {
    name: '12/padding',
    value: '12px',
    describe: '12 内边距',
    token: 'Padding-12',
    locked: true,
  },
  {
    name: '13/padding',
    value: '13px',
    describe: '13 内边距',
    token: 'Padding-13',
    locked: true,
  },
  {
    name: '14/padding',
    value: '14px',
    describe: '14 内边距',
    token: 'Padding-14',
    locked: true,
  },
  {
    name: '15/padding',
    value: '15px',
    describe: '15 内边距',
    token: 'Padding-15',
    locked: true,
  },
  {
    name: '16/padding',
    value: '16px',
    describe: '16 内边距',
    token: 'Padding-16',
    locked: true,
  },
  {
    name: '17/padding',
    value: '17px',
    describe: '17 内边距',
    token: 'Padding-17',
    locked: true,
  },
  {
    name: '18/padding',
    value: '18px',
    describe: '18 内边距',
    token: 'Padding-18',
    locked: true,
  },
  {
    name: '19/padding',
    value: '19px',
    describe: '19 内边距',
    token: 'Padding-19',
    locked: true,
  },
  {
    name: '20/padding',
    value: '20px',
    describe: '20 内边距',
    token: 'Padding-20',
    locked: true,
  },
  {
    name: '21/padding',
    value: '21px',
    describe: '21 内边距',
    token: 'Padding-21',
    locked: true,
  },
  {
    name: '22/padding',
    value: '22px',
    describe: '22 内边距',
    token: 'Padding-22',
    locked: true,
  },
  {
    name: '23/padding',
    value: '23px',
    describe: '23 内边距',
    token: 'Padding-23',
    locked: true,
  },
  {
    name: '24/padding',
    value: '24px',
    describe: '24 内边距',
    token: 'Padding-24',
    locked: true,
  },
  {
    name: '4/margin',
    value: '4px',
    describe: '4 外边距',
    token: 'Margin-4',
    locked: true,
  },
  {
    name: '8/margin',
    value: '8px',
    describe: '8 外边距',
    token: 'Margin-8',
    locked: true,
  },
  {
    name: '12/margin',
    value: '12px',
    describe: '12 外边距',
    token: 'Margin-12',
    locked: true,
  },
  {
    name: '16/margin',
    value: '16px',
    describe: '16 外边距',
    token: 'Margin-16',
    locked: true,
  },
  {
    name: '24/margin',
    value: '24px',
    describe: '24 外边距',
    token: 'Margin-24',
    locked: true,
  },
  {
    name: '32/margin',
    value: '32px',
    describe: '32 外边距',
    token: 'Margin-32',
    locked: true,
  },
  {
    name: '0/radius',
    value: '0px',
    describe: '直角',
    token: 'Radius-0',
    locked: true,
  },
  {
    name: '2/radius',
    value: '2px',
    describe: '2 圆角',
    token: 'Radius-2',
    locked: true,
  },
  {
    name: '3/radius',
    value: '3px',
    describe: '3 圆角',
    token: 'Radius-3',
    locked: true,
  },
  {
    name: '4/radius',
    value: '4px',
    describe: '4 圆角',
    token: 'Radius-4',
    locked: true,
  },
  {
    name: '8/radius',
    value: '8px',
    describe: '8 圆角',
    token: 'Radius-8',
    locked: true,
  },
  {
    name: '12/radius',
    value: '12px',
    describe: '12 圆角',
    token: 'Radius-12',
    locked: true,
  },
  {
    name: '1000/radius',
    value: '1000px',
    describe: '1000 大圆角',
    token: 'Radius-1000',
    locked: true,
  },
  {
    name: '基础阴影',
    value: '0px 2px 5px rgba(2, 11, 24, 0.1)',
    describe: '表格拖拽、树组件拖拽',
    token: 'Shadow-1',
    locked: true,
  },
  {
    name: '中阴影',
    value: '0px 4px 10px rgba(2, 11, 24, 0.1)',
    describe: '所有下拉组件使用，下拉菜单、气泡确认框、选择器',
    token: 'Shadow-2',
    locked: true,
  },
  {
    name: '重阴影',
    value: '0px 8px 20px rgba(2, 11, 24, 0.1)',
    describe: '所有下拉组件使用，下拉菜单、气泡确认框、选择器',
    token: 'Shadow-3',
    locked: true,
  },
  {
    name: 'Shadow-4',
    value: '0 -2px 10px rgba(102,108,124,0.08)',
    describe: '详情页底部按钮模块阴影（向上）',
    token: 'Shadow-4',
    locked: true,
  },
  {
    name: 'Shadow-5',
    value: '0 2px 10px rgba(102,108,124,0.08)',
    describe: '详情页底部按钮模块阴影（向下）',
    token: 'Shadow-5',
    locked: true,
  },
  {
    name: '动态行高',
    value: 'calc( 1em + 8px )',
    describe: '根据当前的字体大小 + 8px',
    token: 'Line-height-dynamic',
    locked: true,
  },
  {
    name: '最小动态行高',
    value: 'calc( max(1em, 14px) + 8px )',
    describe: '根据当前的字体大小 + 8px，但字体大小小于 14px 时，使用 14px 计算',
    token: 'Line-height-dynamic-min',
    locked: true,
  },
  {
    name: '透明色',
    value: 'transparent',
    describe: '较粗边框宽度',
    token: 'Transparent',
    locked: true,
  },
  {
    name: 'colorMaskFill',
    value: 'rgba(2, 11, 24, 0.3)',
    describe: '遮罩填充色',
    token: 'Mask-fill-1',
    locked: false,
  },
  {
    name: '尺寸基数',
    value: '2',
    describe: '尺寸基数，以乘积形式生成所有尺寸，比如：Size * 4px = 8px',
    token: 'Size',
    locked: true,
  },
  {
    name: 'borderRadiusRect',
    value: '0px',
    describe: '直角 Radius-rect (0px)',
    token: 'Radius-rect',
    locked: true,
  },
  {
    name: 'borderRadiusLesser',
    value: '2px',
    describe: '小 Radius-lesser (2px)',
    token: 'Radius-lesser',
    locked: true,
  },
  {
    name: 'borderRadiusSmall',
    value: '3px',
    describe: '较小 Radius-small (3px)',
    token: 'Radius-small',
    locked: true,
  },
  {
    name: 'borderRadiusDefault',
    value: '4px',
    describe: '常规 Radius-default (4px)',
    token: 'Radius-default',
    locked: true,
  },
  {
    name: 'borderRadiusLarge',
    value: '8px',
    describe: '大 Radius-large (8px)',
    token: 'Radius-large',
    locked: true,
  },
  {
    name: 'borderRadiusFull',
    value: '1000px',
    describe: '超大 Radius-full (1000px)',
    token: 'Radius-full',
    locked: true,
  },
  {
    name: 'borderRadiusCircle',
    value: '50%',
    describe: '全圆角 Radius-circle (50%)',
    token: 'Radius-circle',
    locked: true,
  },
  {
    name: '无边框',
    value: '0px',
    describe: '无边框 (0px)',
    token: 'Border-0',
    locked: true,
  },
  {
    name: '常规',
    value: '1px',
    describe: '常规 Border-1',
    token: 'Border-1',
    locked: true,
  },
  {
    name: '较粗',
    value: '2px',
    describe: '较粗 Border-2',
    token: 'Border-2',
    locked: true,
  },
  {
    name: '粗',
    value: '3px',
    describe: '粗 Border-3',
    token: 'Border-3',
    locked: true,
  },
  {
    name: '细体',
    value: '300',
    describe: '细体 Light',
    token: 'Weight-light',
    locked: true,
  },
  {
    name: '常规',
    value: '400',
    describe: '常规 Regular',
    token: 'Weight-regular',
    locked: true,
  },
  {
    name: '中等',
    value: '500',
    describe: '中等 Medium',
    token: 'Weight-medium',
    locked: true,
  },
  {
    name: '较粗',
    value: '600',
    describe: '较粗 Semibold',
    token: 'Weight-Semibold',
    locked: true,
  },
  {
    name: '粗体',
    value: '700',
    describe: '粗体 Bold',
    token: 'Weight-Bold',
    locked: true,
  },
  {
    name: '提示、标签、辅助文案',
    value: '12px',
    describe: '提示、标签、辅助文案 (12px)',
    token: 'Font-12',
    locked: true,
  },
  {
    name: '正文内容',
    value: '14px',
    describe: '正文内容 (14px)',
    token: 'Font-14',
    locked: true,
  },
  {
    name: '标题-小',
    value: '16px',
    describe: '标题-小 (16px)',
    token: 'Font-16',
    locked: true,
  },
  {
    name: '标题-中',
    value: '18px',
    describe: '标题-中 (18px)',
    token: 'Font-18',
    locked: true,
  },
  {
    name: '标题-大',
    value: '20px',
    describe: '标题-大 (20px)',
    token: 'Font-20',
    locked: true,
  },
  {
    name: '标题-较大',
    value: '24px',
    describe: '标题-较大 (24px)',
    token: 'Font-24',
    locked: true,
  },
  {
    name: '重点文本',
    value: '28px',
    describe: '重点文本 (28px)',
    token: 'Font-28',
    locked: true,
  },
  {
    name: '运营数据-小',
    value: '32px',
    describe: '运营数据-小 (32px)',
    token: 'Font-32',
    locked: true,
  },
  {
    name: '运营数据-中',
    value: '36px',
    describe: '运营数据-中 (36px)',
    token: 'Font-36',
    locked: true,
  },
  {
    name: '运营数据-大',
    value: '48px',
    describe: '运营数据-大 (48px)',
    token: 'Font-48',
    locked: true,
  },
  {
    name: 'Spacing-0',
    value: '0px',
    describe: 'Spacing-0 (0px)',
    token: 'Spacing-0',
    locked: true,
  },
  {
    name: 'Spacing-1',
    value: '1px',
    describe: 'Spacing-1 (1px)',
    token: 'Spacing-1',
    locked: true,
  },
  {
    name: 'Spacing-2',
    value: '2px',
    describe: 'Spacing-2 (2px)',
    token: 'Spacing-2',
    locked: true,
  },
  {
    name: 'Spacing-3',
    value: '3px',
    describe: 'Spacing-3 (3px)',
    token: 'Spacing-3',
    locked: true,
  },
  {
    name: 'Spacing-4',
    value: '4px',
    describe: 'Spacing-4 (4px)',
    token: 'Spacing-4',
    locked: true,
  },
  {
    name: 'Spacing-5',
    value: '5px',
    describe: 'Spacing-5 (5px)',
    token: 'Spacing-5',
    locked: true,
  },
  {
    name: 'Spacing-6',
    value: '6px',
    describe: 'Spacing-6 (6px)',
    token: 'Spacing-6',
    locked: true,
  },
  {
    name: 'Spacing-7',
    value: '7px',
    describe: 'Spacing-7 (7px)',
    token: 'Spacing-7',
    locked: true,
  },
  {
    name: 'Spacing-8',
    value: '8px',
    describe: 'Spacing-8 (8px)',
    token: 'Spacing-8',
    locked: true,
  },
  {
    name: 'Spacing-9',
    value: '9px',
    describe: 'Spacing-9 (9px)',
    token: 'Spacing-9',
    locked: true,
  },
  {
    name: 'Spacing-10',
    value: '10px',
    describe: 'Spacing-10 (10px)',
    token: 'Spacing-10',
    locked: true,
  },
  {
    name: 'Spacing-11',
    value: '11px',
    describe: 'Spacing-11 (11px)',
    token: 'Spacing-11',
    locked: true,
  },
  {
    name: 'Spacing-12',
    value: '12px',
    describe: 'Spacing-12 (12px)',
    token: 'Spacing-12',
    locked: true,
  },
  {
    name: 'Spacing-13',
    value: '13px',
    describe: 'Spacing-13 (13px)',
    token: 'Spacing-13',
    locked: true,
  },
  {
    name: 'Spacing-14',
    value: '14px',
    describe: 'Spacing-14 (14px)',
    token: 'Spacing-14',
    locked: true,
  },
  {
    name: 'Spacing-15',
    value: '15px',
    describe: 'Spacing-15 (15px)',
    token: 'Spacing-15',
    locked: true,
  },
  {
    name: 'Spacing-16',
    value: '16px',
    describe: 'Spacing-16 (16px)',
    token: 'Spacing-16',
    locked: true,
  },
  {
    name: 'Spacing-17',
    value: '17px',
    describe: 'Spacing-17 (17px)',
    token: 'Spacing-17',
    locked: true,
  },
  {
    name: 'Spacing-18',
    value: '18px',
    describe: 'Spacing-18 (18px)',
    token: 'Spacing-18',
    locked: true,
  },
  {
    name: 'Spacing-19',
    value: '19px',
    describe: 'Spacing-19 (19px)',
    token: 'Spacing-19',
    locked: true,
  },
  {
    name: 'Spacing-20',
    value: '20px',
    describe: 'Spacing-20 (20px)',
    token: 'Spacing-20',
    locked: true,
  },
  {
    name: 'Spacing-21',
    value: '21px',
    describe: 'Spacing-21 (21px)',
    token: 'Spacing-21',
    locked: true,
  },
  {
    name: 'Spacing-22',
    value: '22px',
    describe: 'Spacing-22 (22px)',
    token: 'Spacing-22',
    locked: true,
  },
  {
    name: 'Spacing-23',
    value: '23px',
    describe: 'Spacing-23 (23px)',
    token: 'Spacing-23',
    locked: true,
  },
  {
    name: 'Spacing-24',
    value: '24px',
    describe: 'Spacing-24 (24px)',
    token: 'Spacing-24',
    locked: true,
  },
  {
    name: 'Spacing-25',
    value: '25px',
    describe: 'Spacing-25 (25px)',
    token: 'Spacing-25',
    locked: true,
  },
  {
    name: 'Spacing-26',
    value: '26px',
    describe: 'Spacing-26 (26px)',
    token: 'Spacing-26',
    locked: true,
  },
  {
    name: 'Spacing-27',
    value: '27px',
    describe: 'Spacing-27 (27px)',
    token: 'Spacing-27',
    locked: true,
  },
  {
    name: 'Spacing-28',
    value: '28px',
    describe: 'Spacing-28 (28px)',
    token: 'Spacing-28',
    locked: true,
  },
  {
    name: 'Spacing-29',
    value: '29px',
    describe: 'Spacing-29 (29px)',
    token: 'Spacing-29',
    locked: true,
  },
  {
    name: 'Spacing-30',
    value: '30px',
    describe: 'Spacing-30 (30px)',
    token: 'Spacing-30',
    locked: true,
  },
  {
    name: 'Spacing-31',
    value: '31px',
    describe: 'Spacing-31 (31px)',
    token: 'Spacing-31',
    locked: true,
  },
  {
    name: 'Spacing-32',
    value: '32px',
    describe: 'Spacing-32 (32px)',
    token: 'Spacing-32',
    locked: true,
  },
  {
    name: 'Spacing-33',
    value: '33px',
    describe: 'Spacing-33 (33px)',
    token: 'Spacing-33',
    locked: true,
  },
  {
    name: 'Spacing-34',
    value: '34px',
    describe: 'Spacing-34 (34px)',
    token: 'Spacing-34',
    locked: true,
  },
  {
    name: 'Spacing-35',
    value: '35px',
    describe: 'Spacing-35 (35px)',
    token: 'Spacing-35',
    locked: true,
  },
  {
    name: 'Spacing-36',
    value: '36px',
    describe: 'Spacing-36 (36px)',
    token: 'Spacing-36',
    locked: true,
  },
  {
    name: 'Spacing-37',
    value: '37px',
    describe: 'Spacing-37 (37px)',
    token: 'Spacing-37',
    locked: true,
  },
  {
    name: 'Spacing-38',
    value: '38px',
    describe: 'Spacing-38 (38px)',
    token: 'Spacing-38',
    locked: true,
  },
  {
    name: 'Spacing-39',
    value: '39px',
    describe: 'Spacing-39 (39px)',
    token: 'Spacing-39',
    locked: true,
  },
  {
    name: 'Spacing-40',
    value: '40px',
    describe: 'Spacing-40 (40px)',
    token: 'Spacing-40',
    locked: true,
  },
  {
    name: 'Spacing-41',
    value: '41px',
    describe: 'Spacing-41 (41px)',
    token: 'Spacing-41',
    locked: true,
  },
  {
    name: 'Spacing-42',
    value: '42px',
    describe: 'Spacing-42 (42px)',
    token: 'Spacing-42',
    locked: true,
  },
  {
    name: 'Spacing-43',
    value: '43px',
    describe: 'Spacing-43 (43px)',
    token: 'Spacing-43',
    locked: true,
  },
  {
    name: 'Spacing-44',
    value: '44px',
    describe: 'Spacing-44 (44px)',
    token: 'Spacing-44',
    locked: true,
  },
  {
    name: 'Spacing-45',
    value: '45px',
    describe: 'Spacing-45 (45px)',
    token: 'Spacing-45',
    locked: true,
  },
  {
    name: 'Spacing-46',
    value: '46px',
    describe: 'Spacing-46 (46px)',
    token: 'Spacing-46',
    locked: true,
  },
  {
    name: 'Spacing-47',
    value: '47px',
    describe: 'Spacing-47 (47px)',
    token: 'Spacing-47',
    locked: true,
  },
  {
    name: 'Spacing-48',
    value: '48px',
    describe: 'Spacing-48 (48px)',
    token: 'Spacing-48',
    locked: true,
  },
  {
    name: 'Size-1',
    value: '2px',
    describe: 'Size-1 (2px)',
    token: 'Size-1',
    locked: true,
  },
  {
    name: 'Size-2',
    value: '4px',
    describe: 'Size-2 (4px)',
    token: 'Size-2',
    locked: true,
  },
  {
    name: 'Size-3',
    value: '6px',
    describe: 'Size-3 (6px)',
    token: 'Size-3',
    locked: true,
  },
  {
    name: 'Size-4',
    value: '8px',
    describe: 'Size-4 (8px)',
    token: 'Size-4',
    locked: true,
  },
  {
    name: 'Size-5',
    value: '10px',
    describe: 'Size-5 (10px)',
    token: 'Size-5',
    locked: true,
  },
  {
    name: 'Size-6',
    value: '12px',
    describe: 'Size-6 (12px)',
    token: 'Size-6',
    locked: true,
  },
  {
    name: 'Size-7',
    value: '14px',
    describe: 'Size-7 (14px)',
    token: 'Size-7',
    locked: true,
  },
  {
    name: 'Size-8',
    value: '16px',
    describe: 'Size-8 (16px)',
    token: 'Size-8',
    locked: true,
  },
  {
    name: 'Size-9',
    value: '18px',
    describe: 'Size-9 (18px)',
    token: 'Size-9',
    locked: true,
  },
  {
    name: 'Size-10',
    value: '20px',
    describe: 'Size-10 (20px)',
    token: 'Size-10',
    locked: true,
  },
  {
    name: 'Size-11',
    value: '22px',
    describe: 'Size-11 (22px)',
    token: 'Size-11',
    locked: true,
  },
  {
    name: 'Size-12',
    value: '24px',
    describe: 'Size-12 (24px)',
    token: 'Size-12',
    locked: true,
  },
  {
    name: 'Size-13',
    value: '26px',
    describe: 'Size-13 (26px)',
    token: 'Size-13',
    locked: true,
  },
  {
    name: 'Size-14',
    value: '28px',
    describe: 'Size-14 (28px)',
    token: 'Size-14',
    locked: true,
  },
  {
    name: 'Size-15',
    value: '30px',
    describe: 'Size-15 (30px)',
    token: 'Size-15',
    locked: true,
  },
  {
    name: 'Size-16',
    value: '32px',
    describe: 'Size-16 (32px)',
    token: 'Size-16',
    locked: true,
  },
  {
    name: 'Size-17',
    value: '34px',
    describe: 'Size-17 (34px)',
    token: 'Size-17',
    locked: true,
  },
  {
    name: 'Size-18',
    value: '36px',
    describe: 'Size-18 (36px)',
    token: 'Size-18',
    locked: true,
  },
  {
    name: 'Size-19',
    value: '38px',
    describe: 'Size-19 (38px)',
    token: 'Size-19',
    locked: true,
  },
  {
    name: 'Size-20',
    value: '40px',
    describe: 'Size-20 (40px)',
    token: 'Size-20',
    locked: true,
  },
  {
    name: 'Size-21',
    value: '42px',
    describe: 'Size-21 (42px)',
    token: 'Size-21',
    locked: true,
  },
  {
    name: 'Size-22',
    value: '44px',
    describe: 'Size-22 (44px)',
    token: 'Size-22',
    locked: true,
  },
  {
    name: 'Size-23',
    value: '46px',
    describe: 'Size-23 (46px)',
    token: 'Size-23',
    locked: true,
  },
  {
    name: 'Size-24',
    value: '48px',
    describe: 'Size-24 (48px)',
    token: 'Size-24',
    locked: true,
  },
  {
    name: 'Size-25',
    value: '50px',
    describe: 'Size-25 (50px)',
    token: 'Size-25',
    locked: true,
  },
  {
    name: 'Size-26',
    value: '52px',
    describe: 'Size-26 (52px)',
    token: 'Size-26',
    locked: true,
  },
  {
    name: 'Size-27',
    value: '54px',
    describe: 'Size-27 (54px)',
    token: 'Size-27',
    locked: true,
  },
  {
    name: 'Size-28',
    value: '56px',
    describe: 'Size-28 (56px)',
    token: 'Size-28',
    locked: true,
  },
];

const compile = (figmaData) => {
  if (!figmaData) return;
  const result = figmaData.map((i) => {
    if (i.value.indexOf('#') > -1) {
      return {
        ...i,
        type: 'color',
      };
    } else {
      return {
        ...i,
        type: 'string',
      };
    }
  });

  return result;
};

module.exports = {
  figma,
  compile,
};
